import { render, staticRenderFns } from "./BaiDu02.vue?vue&type=template&id=85a214b4&scoped=true"
import script from "./BaiDu02.vue?vue&type=script&lang=js"
export * from "./BaiDu02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a214b4",
  null
  
)

export default component.exports